import { PropsWithChildren } from "react";
import {
  LoadingSpinner,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { TooltipProvider } from "@radix-ui/react-tooltip";

type Props = PropsWithChildren<{
  tooltipText: string;
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
}>;

export const TooltipContainer = ({
  tooltipText,
  children,
  side = "bottom",
  sideOffset = 5,
}: Props) => (
  <div>
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side} sideOffset={sideOffset}>
          <div>
            <p>{tooltipText}</p>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>
);

export default TooltipContainer;
